// extracted by mini-css-extract-plugin
export var cartIcon = "_no-0";
export var cartIconContainer = "_no-1";